export const aboutData = {
    title: {
        en: "About Me",
        fr: "À Propos de Moi"
    },
    description: {
        en: "I am a third-year Software Engineering student at the National School of Applied Sciences in Khouribga (ENSAK). Originally from Casablanca, Morocco, I specialize in Software design Engineerig.",
        fr: "Je suis un étudiant en troisième année de Génie Logiciel à l'École Nationale des Sciences Appliquées de Khouribga (ENSAK). Originaire de Casablanca, Maroc, je me spécialise en conception et ingénierie logicielle."
    },
    image: 2
};
